<template>
  <v-container fluid class="px-0">
    <v-row>
      <v-col :cols="!$getAllowedModules()['mobile'] ? 8 : 6">
        <v-card v-if="!cardLoading" height="142">
          <v-card-title class="card-name pt-3"> Ofertas com imagem </v-card-title>
          <v-card-text>
            <v-progress-linear :value="percentualSalesWithImage" color="marca-0" height="35" background-color="marca-1" rounded />

            <v-row align="center" class="mt-2">
              <v-col cols="6" class="pt-2 d-flex">
                <div class="dot-info">
                  <div class="dot marca-0" />
                </div>
                <span class="caption" style="opacity: 0.6">Com imagem {{ salesWithImageCount }} ({{ percentualSalesWithImage | localeString(2) }}%)</span>
              </v-col>
              <v-col cols="6" class="pt-2 d-flex">
                <div class="dot-info">
                  <div class="dot marca-1" />
                </div>
                <span class="caption" style="opacity: 0.6"
                  >Sem imagem {{ salesCount - salesWithImageCount }} ({{ percentualSalesWithoutImage | localeString(2) }}%)</span
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card v-else height="142">
          <v-row>
            <vue-content-loading :height="110">
              <rect x="5%" y="20px" rx="3" ry="2" width="90%" height="15px" />
              <rect x="5%" y="40px" rx="4" ry="2" width="90%" height="15px" />
            </vue-content-loading>
          </v-row>
        </v-card>
      </v-col>
      <v-col v-for="(card, index) in cardsInfo" :key="index" :cols="!$getAllowedModules()['mobile'] ? 4 : 3">
        <cbm-card
          :number-text="card.value"
          :title="card.text"
          :boolean-loader="card.booleanLoader"
          :percent-text="card.underText"
          :percent-description="card.description"
          unset-percentage-colors
          simple-card
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AGGREGATED_SALES_INFO } from '../../graphql'
import VueContentLoading from 'vue-content-loading'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'ProductsCards',
  components: {
    CbmCard: () => import('@/components/CbmCard.vue'),
    VueContentLoading,
  },
  data: () => ({
    cardLoading: false,
    salesCount: 0,
    salesWithImageCount: 0,
    activatableSalesCount: 0,
    personalizedSalesCount: 0,
  }),
  computed: {
    percentualSalesWithImage() {
      return this.calculateBasedSalesCount(this.salesWithImageCount)
    },
    percentualSalesWithoutImage() {
      return isNaN(this.percentualSalesWithImage) ? 0 : 100 - this.percentualSalesWithImage
    },
    cardsInfo() {
      if (!this.$getAllowedModules()['mobile']) {
        return [
          {
            text: 'Ofertas personalizadas',
            value: localeString(this.personalizedSalesCount || 0),
            underText: `${localeString(this.calculateBasedSalesCount(this.personalizedSalesCount) || 0, 1)}%`,
            description: 'do total de ofertas',
            booleanLoader: this.cardLoading,
          },
        ]
      }
      return [
        {
          text: 'Ofertas ativáveis',
          value: localeString(this.activatableSalesCount || 0),
          underText: `${localeString(this.calculateBasedSalesCount(this.activatableSalesCount), 1)}%`,
          description: 'do total de ofertas',
          booleanLoader: this.cardLoading,
        },
        {
          text: 'Ofertas personalizadas',
          value: localeString(this.personalizedSalesCount || 0),
          underText: `${localeString(this.calculateBasedSalesCount(this.personalizedSalesCount), 1)}%`,
          description: 'do total de ofertas',
          booleanLoader: this.cardLoading,
        },
      ]
    },
  },
  mounted() {
    this.getCardsInfo()
  },
  methods: {
    async getCardsInfo() {
      this.cardLoading = true
      await this.$apollo
        .query({
          query: AGGREGATED_SALES_INFO,
          context: {
            uri: this.$microservicesUrls['sales'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { aggregatedSalesInfo } }) => {
          this.salesCount = aggregatedSalesInfo.sales_count
          this.salesWithImageCount = aggregatedSalesInfo.sales_with_image_count
          this.activatableSalesCount = aggregatedSalesInfo.activatable_sales_count
          this.personalizedSalesCount = aggregatedSalesInfo.personalized_sales_count
          this.cardLoading = false
        })
    },
    calculateBasedSalesCount(value) {
      return this.salesCount ? (value / this.salesCount) * 100 : 0
    },
  },
}
</script>

<style lang="scss" scoped>
.dot-info {
  height: 20px;
  width: 20px;
  margin: 0 !important;
  padding: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  & .dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    padding: 5px;
  }
}
.v-card__title {
  padding-bottom: 12px !important;
  margin: 0 !important;
}
.card-name {
  font-size: 16px;
  font-weight: normal;
  opacity: 0.6;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
